type EventLoopDelayState = {
  interval?: ReturnType<typeof setInterval>;
  lastExpectedAtMs: number;
  maxDelayMs: number;
  samples: number;
  totalDelayMs: number;
};

const EVENT_LOOP_DELAY_KEY = '__BZ_OUTBOUND_REQUEST_EVENT_LOOP_DELAY__';
const EVENT_LOOP_DELAY_INTERVAL_MS = 100;

const getGlobalWithEventLoopDelay = (): typeof globalThis & {
  [EVENT_LOOP_DELAY_KEY]?: EventLoopDelayState;
} =>
  globalThis as typeof globalThis & {
    [EVENT_LOOP_DELAY_KEY]?: EventLoopDelayState;
  };

function ensureEventLoopDelayState(): EventLoopDelayState | null {
  if (typeof window !== 'undefined') return null;

  const globalWithEventLoopDelay = getGlobalWithEventLoopDelay();
  let state = globalWithEventLoopDelay[EVENT_LOOP_DELAY_KEY];
  if (state) return state;

  state = {
    lastExpectedAtMs: Date.now() + EVENT_LOOP_DELAY_INTERVAL_MS,
    maxDelayMs: 0,
    samples: 0,
    totalDelayMs: 0,
  };

  state.interval = setInterval(() => {
    const now = Date.now();
    const delayMs = Math.max(0, now - state.lastExpectedAtMs);
    state.lastExpectedAtMs = now + EVENT_LOOP_DELAY_INTERVAL_MS;
    state.maxDelayMs = Math.max(state.maxDelayMs, delayMs);
    state.samples += 1;
    state.totalDelayMs += delayMs;
  }, EVENT_LOOP_DELAY_INTERVAL_MS);
  state.interval.unref?.();

  globalWithEventLoopDelay[EVENT_LOOP_DELAY_KEY] = state;
  return state;
}

export function getEventLoopDelaySnapshot(): { avgDelayMs: number; maxDelayMs: number; samples: number } | undefined {
  const state = ensureEventLoopDelayState();
  if (!state || state.samples === 0) return undefined;

  return {
    avgDelayMs: Math.round(state.totalDelayMs / state.samples),
    maxDelayMs: Math.round(state.maxDelayMs),
    samples: state.samples,
  };
}

ensureEventLoopDelayState();
